/** Zentriert Anruf-Modal und Einwand-Panel nebeneinander ohne Überlappung */

export const CALL_MODAL_WIDTH = 480;
export const CALL_OBJECTION_GAP = 16;
export const PAIRED_OBJECTION_WIDTH = 520;
export const PAIRED_OBJECTION_HEIGHT = 520;

export function layoutCallAndObjectionPanels(opts = {}) {
  const callW = opts.callW ?? CALL_MODAL_WIDTH;
  const objW = opts.objW ?? PAIRED_OBJECTION_WIDTH;
  const gap = opts.gap ?? CALL_OBJECTION_GAP;
  const callH = opts.callH ?? 620;
  const objH = opts.objH ?? PAIRED_OBJECTION_HEIGHT;

  const vw = typeof window !== 'undefined' ? window.innerWidth : 1280;
  const vh = typeof window !== 'undefined' ? window.innerHeight : 800;

  const totalW = callW + gap + objW;
  const x0 = Math.max(12, Math.round((vw - totalW) / 2));
  const y = Math.max(20, Math.round((vh - Math.max(callH, objH)) / 2));

  return {
    call: { x: x0, y },
    objection: { x: x0 + callW + gap, y },
    objectionSize: { w: objW, h: objH },
  };
}
